import { browserTracingIntegration, extraErrorDataIntegration, init } from '@sentry/vue'
import type { App } from 'vue'

import router from '@/router'

export function createSentry(app: App<Element>) {
    init({
        app,
        dsn: 'https://489d5e218191908c391340c50323e69a@sentry.it-team.cloud/162',
        tracePropagationTargets: ['localhost', 'localhost:5173'],
        integrations: [
            browserTracingIntegration({
                router
            }),
            extraErrorDataIntegration()
        ]
    })
}
